export const CUSTOM_SVG_ICONS = {
  'arrow-down': 'icons/arrow_down.svg',
  'arrow-up': 'icons/arrow_up.svg',
  hub: 'icons/hub-icon.svg',
  finance: 'icons/finance-icon.svg',
  operations: 'icons/operations-icon.svg',
  talent: 'icons/talent-icon.svg',
  legal: 'icons/legal-icon.svg',
  sales: 'icons/sales-icon.svg',
  marketing: 'icons/marketing-icon.svg',
  settings: 'icons/settings-icon.svg',
  user: 'icons/user-icon.svg',
  relay: 'icons/earth-check-icon.svg',
  signals: 'icons/signals-icon.svg',
  integrations: 'icons/integrations-icon.svg',
  'platform-ops': 'icons/platform-ops-icon.svg',
  dashboard: 'icons/dashboard-icon.svg',
  contacts: 'icons/contacts-icon.svg',
  invoices: 'icons/invoices-icon.svg',
  payments: 'icons/cash-payment-bill-icon.svg',
  commissions: 'icons/business-deal-cash-exchange-icon.svg',
  metrics: 'icons/customer-relationship-management-icon.svg',
  projects: 'icons/human-resources-hierarchy-icon.svg',
  assignments: 'icons/elastic-load-balance-circle-icon.svg',
  timesheets: 'icons/workflow-data-table-time-icon.svg',
  recruiters: 'icons/single-neutral-find-icon.svg',
  candidates: 'icons/recruiting-employee-target-icon.svg',
  'team-members': 'icons/team-meeting-icon.svg',
  leads: 'icons/audience-target-user-icon.svg',
  clients: 'icons/business-deal-handshake-icon.svg',
  'lead-generators': 'icons/tiger-shark-icon.svg',
  logout: 'icons/logout-icon.svg',
  'finance-overview': 'icons/finance-overview-icon.svg',
  transactions: 'icons/data-transfer-horizontal-icon.svg',
  'receipt-dollar': 'icons/receipt-dollar-icon.svg',
  'expense-tracking-bill': 'icons/expense-tracking-bill-icon.svg',
  'time-clock-file-cash': 'icons/time-clock-file-cash-icon.svg',
  'accounting-bill-stack': 'icons/accounting-bill-stack-icon.svg',
  'earth-check': 'icons/earth-check-icon.svg',
  compliance: 'icons/compliance-icon.svg',
  'performance-increase': 'icons/performance-increase-icon.svg',
  'saving-bag-increase': 'icons/saving-bag-increase-icon.svg',
  'currency-dollar-increase': 'icons/currency-dollar-increase-icon.svg',
  'cash-payment-bag': 'icons/cash-payment-bag-icon.svg',
  'calendar-3': 'icons/calendar-3-icon.svg',
  'arrow-right-small': 'icons/arrow-right-small-icon.svg',
  'arrow-down-small': 'icons/arrow-down-small-icon.svg',
  'drag-handle': 'icons/drag-handle-icon.svg',
  'invoice-line-item': 'icons/invoice-line-item-icon.svg',
  'invoice-line-expense': 'icons/invoice-line-expense-icon.svg',
  'invoice-line-discount': 'icons/invoice-line-discount-icon.svg',
  'accounting-invoice': 'icons/accounting-invoice-icon.svg',
  'file-upload': 'icons/file-upload-icon.svg',
  'invoice-actions-chevron': 'icons/invoice-actions-chevron.svg',
  'invoice-action-edit': 'icons/invoice-action-edit.svg',
  'invoice-action-mark-paid': 'icons/invoice-action-mark-paid.svg',
  'invoice-action-mark-sent': 'icons/invoice-action-mark-sent.svg',
  'invoice-action-mark-draft': 'icons/invoice-action-mark-draft.svg',
  'invoice-action-mark-closed': 'icons/invoice-action-mark-closed.svg',
  'invoice-action-send-reminder': 'icons/invoice-action-send-reminder.svg',
  'invoice-action-send-invoice': 'icons/invoice-action-send-invoice.svg',
  'invoice-action-download-pdf': 'icons/invoice-action-download-pdf.svg',
  'invoice-action-public-preview': 'icons/invoice-action-public-preview.svg',
  'invoice-action-duplicate': 'icons/invoice-action-duplicate.svg',
  'invoice-action-delete': 'icons/invoice-action-delete.svg',
  'more-vertical': 'icons/more-vertical-icon.svg',
  'commission-notes': 'icons/commission-notes-icon.svg',
  'commission-attach': 'icons/commission-attach-icon.svg',
  linkedin: 'icons/linkedin.svg',
  'linkedin-icon': 'icons/linkedin_icon.svg',
  'preview-icon': 'icons/preview_icon.svg',
  'download-icon': 'icons/download_icon.svg',
  'find-recruiter-icon': 'icons/find_recruiter_icon.svg',
  'candidate-resume-icon': 'icons/candidate_resume_icon.svg',
  'next-stage-icon': 'icons/next_stage_icon.svg',
  'skull-icon': 'icons/skull-icon.svg',
  vendor: 'icons/vendor-icon.svg',
  'convert2client-icon': 'icons/convert2client_icon.svg',
  'claude-kebab': 'icons/claude-kebab.svg',
} as const;

export type CustomSvgIconName = keyof typeof CUSTOM_SVG_ICONS;
